export default [
    { //管理员配置
        path: '/systemLayout/administrator',
        name:'systemLayoutAdministrator',
        meta: { title: '管理员配置'},
        component: () => import('../../views/systemLayout/administrator.vue')
    },
    { //添加管理员配置
      path: '/systemLayout/administrator/add/:id?',
      name:'systemLayoutAdministratorAdd',
      meta: { title: '添加管理员配置'},
      component: () => import('../../views/systemLayout/administratorAdd.vue')
  },
  { //管理员详情
    path: '/systemLayout/administrator/detail/:id',
    name:'systemLayoutAdministratorDetail',
    meta: { title: '管理员详情'},
    component: () => import('../../views/systemLayout/administratorDetail.vue')
},
    { //角色权限管理
        path: '/systemLayout/character',
        name:'systemLayoutCharacter',
        meta: { title: '角色权限管理'},
        component: () => import('../../views/systemLayout/character.vue')
    },
    { //添加角色权限
      path: '/systemLayout/character/add/:id?',
      name:'systemLayoutCharacterAdd',
      meta: { title: '添加角色权限'},
      component: () => import('../../views/systemLayout/characterAdd.vue')
  },
  { //编辑角色权限
    path: '/systemLayout/character/edit/:id?',
    name:'systemLayoutCharacterEdit',
    meta: { title: '编辑角色权限'},
    component: () => import('../../views/systemLayout/characterEdit.vue')
},
  { //角色权限明细
    path: '/systemLayout/character/detail/:id',
    name:'systemLayoutCharacterDetail',
    meta: { title: '角色权限明细'},
    component: () => import('../../views/systemLayout/characterDetail.vue')
},
{ //分配角色权限
  path: '/systemLayout/character/auth/:id',
  name:'systemLayoutCharacterAuth',
  meta: { title: '分配角色权限'},
  component: () => import('../../views/systemLayout/characterAuth.vue')
},
    { //banner管理
        path: '/systemLayout/banner',
        name:'systemLayoutBanner',
        meta: { title: 'banner管理'},
        component: () => import('../../views/systemLayout/banner.vue')
    },
    { //发布banner
        path: '/systemLayout/bannerEdit/:type/:id?',
        name:'systemLayoutBannerEdit',
        meta: { title: '发布banner'},
        component: () => import('../../views/systemLayout/bannerEdit.vue')
    },
    { //前端配置
        path: '/systemLayout/configuration',
        name:'systemLayoutConfiguration',
        meta: { title: '前端配置'},
        component: () => import('../../views/systemLayout/configuration/index.vue'),
        children:[
            { //基金合作-附件
                path: 'configurationFirst',
                name:'systemLayoutConfigurationFirst',
                meta: { title: '基金合作-附件'},
                component: () => import('../../views/systemLayout/configuration/configurationFirst.vue')
            },
            { //添加基金合作-附件
              path: 'configurationFirst/add',
              name:'systemLayoutConfigurationFirstAdd',
              meta: { title: '新增基金合作-附件'},
              component: () => import('../../views/systemLayout/configuration/configurationFirstAdd.vue')
          },
            { //基金合作-合作机构
                path: 'configurationSecond',
                name:'systemLayoutConfigurationSecond',
                meta: { title: '基金合作-合作机构'},
                component: () => import('../../views/systemLayout/configuration/configurationSecond.vue')
            },
            { //基金合作-合作机构
              path: 'configurationSecond/edit/:id?',
              name:'systemLayoutConfigurationSecondAdd',
              meta: { title: '添加基金合作-合作机构'},
              component: () => import('../../views/systemLayout/configuration/configurationSecondAdd.vue')
          },
            { //担保服务-附件
                path: 'configurationThird',
                name:'systemLayoutConfigurationThird',
                meta: { title: '担保服务-附件'},
                component: () => import('../../views/systemLayout/configuration/configurationThird.vue')
            },
            { //担保服务-附件
              path: 'configurationThird/add',
              name:'systemLayoutConfigurationThirdAdd',
              meta: { title: '添加担保服务-附件'},
              component: () => import('../../views/systemLayout/configuration/configurationThirdAdd.vue')
          },
            { //联系我们
                path: 'configurationFourth',
                name:'systemLayoutConfigurationFourth',
                meta: { title: '联系我们'},
                component: () => import('../../views/systemLayout/configuration/configurationFourth.vue')
            },
            { //集群托管服务-附件
              path: 'configurationFive',
              name:'systemLayoutConfigurationFive',
              meta: { title: '基金合作-附件'},
              component: () => import('../../views/systemLayout/configuration/configurationFive.vue')
          },
          { //添加集群托管服务-附件
            path: 'configurationFive/add',
            name:'systemLayoutConfigurationFiveAdd',
            meta: { title: '新增基金合作-附件'},
            component: () => import('../../views/systemLayout/configuration/configurationFiveAdd.vue')
        },
        ]
    },
    { //短信管理
        path: '/systemLayout/SMSManager',
        name:'systemLayoutSMSManager',
        meta: { title: '短信管理'},
        component: () => import('../../views/systemLayout/SMSManager.vue')
    },
    { //字典配置
        path: '/systemLayout/dictionary',
        name:'systemLayoutDictionary',
        meta: { title: '字典配置'},
        component: () => import('../../views/systemLayout/dictionary.vue')
    },
    { //运营成果配置 
        path: '/systemLayout/OperationalResults',
        name:'OperationalResults',
        meta: { title: '运营成果配置'},
        component: () => import('../../views/systemLayout/OperationalResults.vue')
    },
    { //编辑运营成果配置 
      path: '/systemLayout/OperationalResults/edit/:id',
      name:'OperationalResultsEdit',
      meta: { title: '编辑运营成果配置'},
      component: () => import('../../views/systemLayout/OperationalResultsEdit.vue')
  },
    { //成功案例配置
        path: '/systemLayout/SuccessfulCases',
        name:'SuccessfulCases',
        meta: { title: '成功案例配置'},
        component: () => import('../../views/systemLayout/SuccessfulCases.vue')
    },
    { //添加成功案例配置
      path: '/systemLayout/SuccessfulCases/add',
      name:'SuccessfulCasesAdd',
      meta: { title: '添加成功案例配置'},
      component: () => import('../../views/systemLayout/SuccessfulCasesAdd.vue')
  },
  { //编辑成功案例配置
    path: '/systemLayout/SuccessfulCases/edit/:id',
    name:'SuccessfulCasesEdit',
    meta: { title: '编辑成功案例配置'},
    component: () => import('../../views/systemLayout/SuccessfulCasesEdit.vue')
},
{ //标签列表
  path: '/systemLayout/tag',
  name:'systemLayoutTag',
  meta: { title: '标签列表'},
  component: () => import('../../views/systemLayout/tag.vue')
},
{ //广告栏管理
  path: '/systemLayout/advertisement',
  name:'systemLayoutAdvertisement',
  meta: { title: '广告栏管理'},
  component: () => import('../../views/systemLayout/advertisement.vue')
},
{ //广告栏添加编辑
  path: '/systemLayout/advertisement/edit/:id?',
  name:'systemLayoutAdvertisementEdit',
  meta: { title: '广告栏编辑'},
  component: () => import('../../views/systemLayout/advertisementEdit.vue')
},
{ //日志
  path: '/systemLayout/advertisement/log',
  name:'systemLayoutAdvertisementLog',
  meta: { title: '操作日志'},
  component: () => import('../../views/systemLayout/log.vue')
},
] 